import styled from 'styled-components';

import { absCenter } from '@sorare/core/src/lib/style';

import { Base } from './Base/index.tsx';
import { DiamondBase } from './DiamondBase/index.tsx';
import { DiamondBorder } from './DiamondBorder/index.tsx';
import type { DiamondBaseColor } from './utils.ts';
import { DiamondBasePosition } from './utils.ts';

const AbsoluteOverlap = styled.div`
  position: relative;

  & > * {
    ${absCenter}
  }
`;

type Props = {
  color: DiamondBaseColor;
  position?: DiamondBasePosition;
  borderAnimated?: boolean;
  scaling?: boolean;
  floating?: boolean;
  size?: number;
};
export const Tile = ({
  color,
  position = DiamondBasePosition.middle,
  borderAnimated,
  scaling,
  floating,
  size = 1,
}: Props) => {
  return (
    <AbsoluteOverlap>
      <DiamondBorder color={color} animated={borderAnimated} size={size} />
      <DiamondBase color={color} position={position} size={size} />
      <Base
        color={color}
        position={position}
        scaling={scaling}
        floating={floating}
        size={size}
      />
    </AbsoluteOverlap>
  );
};
